import { useState } from "react";
import { CircleUserRound } from "lucide-react";
 import { Logout } from "../user/Logout";
import { DropdownItem } from "../ui/dropdown/DropdownItem";
import { Dropdown } from "../ui/dropdown/Dropdown";
import BlobImage from "../ui/image/BlobImage";
import { useAuth } from "@repo/hooks/contexts";

export default function UserDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();

  function toggleDropdown() {
    setIsOpen(!isOpen);
  }

  function closeDropdown() {
    setIsOpen(false);
  }
  return (
    <div className="relative">
      <button
        onClick={toggleDropdown}
        className="flex items-center text-gray-700 dropdown-toggle hover:cursor-pointer"
      >
        <span className="block mr-1 text-sm">{user?.Name}</span>

        <BlobImage
          src={user?.ProfilePicPath}
          className="w-9 h-9 rounded-full object-cover"
          fallback={<CircleUserRound size={30} />}
        />
      </button>

      <Dropdown
        isOpen={isOpen}
        onClose={closeDropdown}
        className="absolute right-0 mt-[17px] flex w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-lg transition-all duration-700 ease-in-out"
      >
        <div>
          <span className="block text-gray-700">{user?.Name}</span>
          <span className="mt-0.5 block text-theme-xs text-gray-500">
            {user?.Email}
          </span>
        </div>

        <ul className="flex flex-col gap-1 pt-4 pb-3 border-b border-gray-200">
          <li>
            <DropdownItem
              onItemClick={closeDropdown}
              tag="a"
              to="/profile"
              className="flex items-center gap-3 px-2 py-1 text-gray-700 rounded-sm group hover:bg-gray-100 hover:text-gray-700"
            >
              <CircleUserRound size={20} className="stroke-gray-500" />
              Edit profile
            </DropdownItem>
          </li>
        </ul>
        <Logout />
      </Dropdown>
    </div>
  );
}

